import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { Box, BoxProps } from '@mui/material';

interface DashboardImagePreviewProps {
  src: string;
  sx: BoxProps['sx'];
  onClick: () => void;
}

function Image({ src, sx, onClick }: DashboardImagePreviewProps) {
  return (
    <Box
      component="img"
      sx={{
        display: 'block',
        width: '100%',
        height: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        objectFit: 'contain',
        objectPosition: 'top',
        ...sx,
      }}
      alt={src}
      src={src}
      onClick={onClick}
    />
  );
}

export function DashboardImagePreview({
  src,
}: Pick<DashboardImagePreviewProps, 'src'>) {
  const { openModal, closeModal } = useMuiModalContext();

  return (
    <Image
      src={src}
      sx={{ cursor: 'zoom-in' }}
      onClick={() => {
        openModal({
          contentComponent: () => (
            <Image
              src={src}
              sx={{
                cursor: 'zoom-out',
                objectFit: 'scale-down',
                objectPosition: 'center',
              }}
              onClick={() => {
                closeModal();
              }}
            />
          ),
          modalProps: {
            maxWidth: 'lg',
            PaperProps: { sx: { height: '100%' } },
          },
        });
      }}
    />
  );
}
